const ROUTE_CAPABILITY = {
  '/aicc/overview': ['voice.overview.read'],
  '/aicc/pds/tasks': ['pds.task.read'],
  '/aicc/pds/agent': ['pds.seat.use'],
  '/aicc/collaboration': ['collab.seat.use'],
  '/aicc/collaboration/records': ['collab.record.read'],
  '/aicc/settings': ['voice.agent.read','voice.group.read','voice.skill.read','voice.queue.read'],
}

const routeLine = path => path.includes('/pds/') ? 'pds' : path.includes('/collaboration') ? 'collaboration' : null
const hasScope = (scopes, line) => {
  if (!line) return true
  const scope = scopes?.[line]
  return scope && typeof scope === 'object' && (scope.organization === true || scope.self === true || ['managed_groups','own_groups','accounts'].some(key => Array.isArray(scope[key]) && scope[key].length > 0))
}

export function buildAiccMenu({ menus, pdsEnabled, managementEnabled, collaborationRecordsEnabled, operationsOverviewEnabled,
  principalType, businessLines, capabilities, scopes } = {}) {
  if (!Array.isArray(menus)) return null
  const allowed = new Set(menus)
  const caps = new Set(Array.isArray(capabilities) ? capabilities : [])
  const lines = new Set(Array.isArray(businessLines) ? businessLines : [])
  const explicit = typeof principalType === 'string' && principalType !== 'legacy'
  const permits = (path, legacy) => {
    if (!explicit) return legacy
    const line = routeLine(path)
    if (line && (!lines.has(line) || !hasScope(scopes, line))) return false
    return ROUTE_CAPABILITY[path].some(capability => caps.has(capability))
  }
  const children = []
  if (allowed.has('aicc_dashboard') && operationsOverviewEnabled === true && permits('/aicc/overview', true)) children.push({ key: '/aicc/overview', label: 'Overview', icon: 'monitor' })
  if (allowed.has('pds_tasks') && pdsEnabled === true && permits('/aicc/pds/tasks', true)) children.push({ key: '/aicc/pds/tasks', label: 'Outbound Tasks', icon: 'Outbound' })
  if (allowed.has('aicc_workbench') && pdsEnabled === true && permits('/aicc/pds/agent', true)) children.push({ key: '/aicc/pds/agent', label: 'PD Agent Desk', icon: 'pds_agent' })
  if (allowed.has('aicc_workbench') && permits('/aicc/collaboration', true)) children.push({ key: '/aicc/collaboration', label: 'AI Handoff Desk', icon: 'handoff_desk' })
  if (allowed.has('aicc_workbench') && allowed.has('robot_calls') && collaborationRecordsEnabled === true && permits('/aicc/collaboration/records', true)) children.push({ key: '/aicc/collaboration/records', label: 'Handoff Records', icon: 'hangoff_records' })
  if (allowed.has('aicc_management') && managementEnabled === true && permits('/aicc/settings', true)) children.push({ key: '/aicc/settings', label: 'Voice Settings', icon: 'settings' })
  return children.length ? { key: 'aicc', label: 'Agent Desk', children } : null
}

const DIRECT_AICC_ROUTES = new Set(['/aicc/overview','/aicc/pds/tasks','/aicc/collaboration/records','/aicc/settings'])
export function isDirectAiccRoute(path) { return DIRECT_AICC_ROUTES.has(path) }

export function canAccessAiccRoute(path, profile) {
  const menu = buildAiccMenu({
    menus: profile?.menus, pdsEnabled: profile?.pds_enabled,
    managementEnabled: profile?.aicc_management_enabled,
    collaborationRecordsEnabled: profile?.collaboration_record_read_enabled,
    operationsOverviewEnabled: profile?.operations_overview_enabled,
    principalType: profile?.principal_type, businessLines: profile?.business_lines,
    capabilities: profile?.capabilities, scopes: profile?.scopes,
  })
  return menu?.children.some(item => item.key === path) === true
}

export function parseGroupRows(body) {
  if (body.code !== 0 && body.code !== 200 && body.code !== '0') throw new Error(body.message || body.msg || 'Group query failed')
  const rows = Array.isArray(body.body) ? body.body : Array.isArray(body.data) ? body.data : body.body?.list ?? body.data?.list
  if (!Array.isArray(rows)) throw new Error('Unexpected group response format')
  return rows
}

export function isPdsEnabled(value) { return value === true }
